import React, { useEffect } from 'react';

import {
    Grid, Group, Image, Title,
} from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import {
    Col, Row,
} from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';

import Fetcher from '../../common/communicate';
import { PROJECT_PREFIX, hosts } from '../../const';
import { useUser } from '../../contexts/user';
import '../../css/index.css';
import Navigation from '../Navigation';
import ProjectSelect from '../ProjectSelect/ProjectSelect';

function Page({ children }) {
    const [currentProject, setCurrentProject] = useLocalStorage({
        key: 'content-project',
        defaultValue: 'media.vkplay.ru',
    });

    const { user, setUser } = useUser();

    function handleUserData(data) {
        setUser(data);
    }

    useEffect(() => {
        Fetcher('auth/', 'GET', handleUserData);
    }, []);

    if (!user) {
        return null;
    }

    return (
        <section className="b-page">
            <Group style={{
                padding: '8px 15px',
                background: '#f8f9fa',
                position: 'relative',
                zIndex: '99',
            }}
            >
                <Group spacing="sm">
                    <Image
                        src={hosts[currentProject]?.icon}
                        width={34}
                    />
                    <Title order={1}>
                        Админка
                        {' '}
                        {hosts[currentProject].label}
                    </Title>
                </Group>
            </Group>
            <Grid style={{ width: '100%' }}>
                <Grid.Col
                    span={2}
                    style={{
                        height: 'calc(100vh - 52px)',
                        borderRight: '1px solid #e9ecef',
                        paddingRight: '0',
                        position: 'relative',
                    }}
                >
                    <Navigation
                        basePath={PROJECT_PREFIX}
                        currentProject={currentProject}
                        aclEndpoints={user?.permissions.endpoints}
                    />
                    <ProjectSelect
                        user={user}
                        currentProject={currentProject}
                        setCurrentProject={setCurrentProject}
                    />
                </Grid.Col>
                <Grid.Col
                    className="main-wrapper"
                    span={10}
                    style={{
                        height: 'calc(100vh - 60px)',
                        overflow: 'auto',
                        scrollBehavior: 'smooth',
                    }}
                >
                    <div className="container-fluid">
                        <ToastContainer
                            position="top-right"
                            autoClose={2000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnVisibilityChange
                            draggable
                            pauseOnHover
                        />

                        <Row className="show-grid">
                            <Col md={12} className="m-0 p-0">
                                <div className="conent_div">
                                    <section className="b-content">
                                        {children}
                                    </section>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Grid.Col>
            </Grid>
        </section>
    );
}

export default Page;
